document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".lume-slide");
  const buttons = document.querySelectorAll(".lume-buttons button");

  buttons.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      // Update button states
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      // Switch slides
      slides.forEach(s => s.classList.remove("active"));
      slides[index].classList.add("active");
    });
  });
});


document.addEventListener("scroll", () => {
  const section = document.querySelector(".hscroll-section");
  const track = document.querySelector(".hscroll-track");
  const sticky = document.querySelector(".hscroll-sticky");

  if (!section || !track || !sticky) return;

  const sectionTop = section.offsetTop;
  const sectionHeight = section.offsetHeight;
  const scrollTop = window.scrollY;

  // Only process when inside section
  if (scrollTop >= sectionTop && scrollTop <= sectionTop + sectionHeight - window.innerHeight) {
    const progress = scrollTop - sectionTop; 
    track.style.transform = `translateX(-${progress}px)`;
  }
});
